import { getFcmToken, login } from '@features/auth/auth.slice';
import { describeNativeBridges, readNativeFcmToken } from '@hooks';
import { consumePendingRedirect } from '../../core/pendingRedirect';
import { useLoginMutation } from '@services';
import { useGetSignatureMutation } from '@services/signature/signature.endpoint';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const useLoginPageVM = () => {
    // const [mail, setMail] = useState<string>('dev5@getup.agency');
    // const [password, setPassword] = useState<string>('1234');
    const [mail, setMail] = useState<string>(localStorage.getItem('lastMail') || '');
    const [password, setPassword] = useState<string>('');

    const fcmToken = useSelector(getFcmToken);

    const dispatch = useDispatch();
    const [loginCall, { isLoading, isSuccess, data, isError, error }] = useLoginMutation();
    const [getSignature, { isLoading: isSignatureLoading }] = useGetSignatureMutation();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // TEMPORAIRE — describeNativeBridges() rapporte ce que le shell natif
        // expose reellement, faute d'acces au projet Xcode. A retirer une fois
        // le pont iOS identifie.
        // Le store peut etre vide alors que le pont natif detient deja le token
        // (REHYDRATE de redux-persist arrive apres le premier rendu et ecrase le
        // slice). On retombe donc sur une lecture directe du pont.
        const token = fcmToken || readNativeFcmToken();

        loginCall({ mail, password, ...(token ? { fcm_token: token } : {}), debug_native: describeNativeBridges() });
    };

    useEffect(() => {
        if (isError && error) {
            return;
        }

        if (isSuccess && data) {
            localStorage.setItem('lastMail', mail);
            dispatch(login(data));
            // Destination issue d'une notification, mise en attente le temps de la
            // connexion. La signature reste prioritaire : elle est obligatoire, et
            // la destination est alors abandonnee plutot que rejouee plus tard, ce
            // qui provoquerait une navigation inattendue.
            const redirectTo = consumePendingRedirect();

            getSignature()
                .unwrap()
                .then((result) => {
                    if (result.signature) {
                        navigate(redirectTo ?? '/home');
                    } else {
                        navigate('/signature');
                    }
                })
                .catch(() => {
                    navigate('/signature');
                });
        }
    }, [isSuccess, isError, data, error, dispatch, getSignature, navigate]);

    return {
        mail,
        password,
        setMail,
        setPassword,
        handleSubmit,
        isLoading: isLoading || isSignatureLoading,
        isSubmitable: useMemo(() => {
            const mailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isMailValid = mailRegex.test(mail);
            const isPasswordValid = password.length > 0;

            return isMailValid && isPasswordValid;
        }, [mail, password])
    };
};
